import type { ConsentPurpose, ConsentState } from '../../lib/consent/contract'

export {
  CONSENT_COOKIE_NAME,
  CONSENT_PURPOSES,
} from '../../lib/consent/contract'
export type {
  ConsentPurpose,
  ConsentState,
  ConsentStatus,
} from '../../lib/consent/contract'

export function canUsePurpose(state: ConsentState | undefined, purpose: ConsentPurpose): boolean {
  return state?.status === 'accepted' && state.expiresAt > Date.now() && state.purposes.includes(purpose)
}

export function hasOptionalConsent(state: ConsentState | undefined): boolean {
  return state?.status === 'accepted' && state.expiresAt > Date.now() && state.purposes.length > 0
}
